<template>
    <div class="about_dom">
        <v-header></v-header>
        <div class="about_dom_image">
            <img class="banner_class" src="https://zyprogram.xinchacha.com/xiansuo/pc/banner_about.png">
            <div class="about_dom_txt">
                <div class="about_dom_txt_div">
                    <div class="title_div">
                        <span class="classSpan">关于我们</span>
                        <p class="txt_dom">
                            提供线上推广信息查询服务，客户线索覆盖四大搜索
                            推广平台、10亿级推广数据。及时更新帮您发现近期
                            有推广的企业，精准获取商机。
                        </p>
                        <div class="btn" @click="goPage('/')">欢迎使用</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="about_body">
            <div class="about_body_div">
                小查线索是北京信查查信用管理有限公司旗下产品。
                小查线索提供更新、更全的网站域名ICP备案信息查询，
                每天实时同步更新大官方数据。致力于为企业销售人员提
                供各种服务和解决各种问题，不再为找不到客户而苦恼！

                <h3>本站特色</h3>
                <p class="item">【实时更新】全面提高全加载速度，给您带来前所未有的实时更新体验</p>
                <p class="item">【备案监控】多地区ICP备案信息监控</p>
                <p class="item">【深度功能】百度推广开通状态、整年备案信息导出功能等，满足大部分用户需求</p>
                <p class="item">【联系方式】可以查询到ICP备案网站信息联系方式</p>
            </div>
        </div>
        <v-footer></v-footer>
    </div>
</template>
<script>
import vHeader from './common/header.vue'
import vFooter from './common/footer.vue'
export default {
    data(){
        return{

        }
    },
    components:{
        vHeader,
        vFooter
    },
    methods:{
        goPage(ourl){
            return this.$router.push({
                path:ourl
            });
        }
    },
    mounted(){

    }
}
</script>
<style lang="scss" scoped>
.about_dom{
    width: 100%;
    height: auto;
    background-color: #FFFFFF;
}
.about_dom_image{
    width: 100%;
    height: auto;
    position: relative;
    >img.banner_class{
        width: 84%;
        height: auto;
        display: block;
    }
    >div.about_dom_txt{
        width: 100%;
        height: auto;
        position: absolute;
        top: 0;
        left: 0;
        >div.about_dom_txt_div{
            height: auto;
            margin: 0 auto;
            padding-top: 1px;
            @media screen and (max-width: 1400px){
                width: 960px;
            }
            @media screen and (min-width: 1400px){
                width: 1200px;
            }
            >div.title_div{
                width: auto;
                height: auto;
                margin-top: 10%;
                >span.classSpan{
                    font-size: 66px;
                    font-weight: 600;
                    color: #FFFFFF;
                    border-bottom: 1px solid #FFFFFF;
                    cursor: default;
                }
                >p.txt_dom{
                    width: 50%;
                    height: auto;
                    line-height: 42px;
                    font-size: 28px;
                    font-weight: 400;
                    color: #FFFFFF;
                    margin-top: 20px;
                    cursor: default;
                }
                >div.btn{
                    width: 202px;
                    height: 58px;
                    line-height: 58px;
                    background: #FFFFFF;
                    border-radius: 8px;
                    margin-top: 30px;
                    font-size: 24px;
                    color: #3062DE;
                    text-align: center;
                    cursor: default;
                }
            }
        }
    }
}

.about_body{
    height: auto;
    margin: 120px auto;
    display: flex;
    justify-content: flex-end;
    background-image: url('https://zyprogram.xinchacha.com/xiansuo/pc/about_body_img.png');
    background-size: 44% auto;
    background-repeat: no-repeat;
    background-position: 0 50%;
    @media screen and (max-width: 1400px){
        width: 960px;
    }
    @media screen and (min-width: 1400px){
        width: 1200px;
    }
    >div.about_body_div{
        width: 50%;
        height: auto;
        font-size: 24px;
        color: #333333;
        line-height: 40px;
        cursor: default;
        >h3{
            font-size: 20px;
            margin-top: 40px;
            cursor: default;
        }
        >p.item{
            font-size: 24px;
            cursor: default;
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/about.vue